"use client"

import * as React from "react"
import { Image, Grid, Puzzle } from "lucide-react"

interface DesktopContextMenuProps {
  contextMenu: { visible: boolean; x: number; y: number }
  onClose: () => void
  onOpenWallpaper: () => void
  onOpenAddApp: () => void
  onOpenAddWidget: () => void
  desktopIconSize?: any
  setDesktopIconSize?: any
}

export function DesktopContextMenu({
  contextMenu,
  onClose,
  onOpenWallpaper,
  onOpenAddApp,
  onOpenAddWidget,
  desktopIconSize,
  setDesktopIconSize,
}: DesktopContextMenuProps) {
  React.useEffect(() => {
    if (!contextMenu.visible) return

    const handleGlobalClick = () => {
      onClose()
    }

    const handleWindowBlur = () => {
      onClose()
    }

    window.addEventListener("click", handleGlobalClick)
    window.addEventListener("blur", handleWindowBlur)
    return () => {
      window.removeEventListener("click", handleGlobalClick)
      window.removeEventListener("blur", handleWindowBlur)
    }
  }, [contextMenu.visible, onClose])

  if (!contextMenu.visible) return null

  return (
    <>
      <div
        className="fixed inset-0 z-50 bg-transparent"
        onClick={onClose}
        onContextMenu={(e) => {
          e.preventDefault()
          onClose()
        }}
      />
      <div
        className="fixed z-55 bg-white/90 dark:bg-zinc-900/90 backdrop-blur-md border border-zinc-200/50 dark:border-zinc-800/50 rounded-xl shadow-2xl py-1.5 min-w-[220px] text-xs font-sans text-zinc-700 dark:text-zinc-300 animate-in fade-in zoom-in-95 duration-100"
        style={{ top: contextMenu.y, left: contextMenu.x }}
        onClick={(e) => e.stopPropagation()}
      >
      <div className="px-3 py-1 text-[10px] font-bold text-zinc-400 dark:text-zinc-550 uppercase tracking-wider select-none">
        Opções da Tela
      </div>
      <button
        onClick={() => {
          onOpenWallpaper()
          onClose()
        }}
        className="w-full text-left px-4 py-2 hover:bg-[#004EB1] hover:text-white flex items-center gap-2.5 cursor-pointer transition-colors"
      >
        <Image className="size-3.5 text-blue-500" />
        <span>Alterar Imagem de Fundo</span>
      </button>
    </div>
    </>
  )
}
